"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepLabel = exports.StepIndicator = exports.StepBarItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconButton = _interopRequireDefault(require("../../../IconButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StepBarItem = exports.StepBarItem = _styledComponents["default"].div.withConfig({
  displayName: "DefaultStepBarItemstyle__StepBarItem",
  componentId: "sc-fsrnsz-0"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: "".concat(spacing.inline['6xs'], " ").concat(spacing.inline['5xs'])
  };
});
var StepLabel = exports.StepLabel = _styledComponents["default"].div.withConfig({
  displayName: "DefaultStepBarItemstyle__StepLabel",
  componentId: "sc-fsrnsz-1"
})(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    marginRight: spacing.inline['6xs'],
    marginLeft: spacing.inline['6xs']
  };
});
var StepIndicator = exports.StepIndicator = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "DefaultStepBarItemstyle__StepIndicator",
  componentId: "sc-fsrnsz-2"
})({
  ':disabled': {
    pointerEvents: 'none',
    opacity: '1'
  }
});